'use client';

import type { Post } from '@routeroyal/theme-core';
import { AllysCTASection, AllysPostArticle } from '@routeroyal/theme-allys';

type Props = {
  article: Post;
  relatedArticles: Post[];
  locale: string;
  messages: Record<string, unknown>;
  basePath: string;
};

export function ArticleContentAllys({ 
  article, 
  relatedArticles, 
  locale,
  messages,
  basePath
}: Props) {
  const handleShare = (platform: 'twitter' | 'facebook' | 'linkedin' | 'copy') => {
    const url = window.location.href;
    const text = article.title;

    let shareUrl = '';

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(url);
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };

  // Get localized messages for the article component
  const articleMessages = (messages?.blog || messages?.posts || {}) as Record<string, string>;

  return (
    <>
      {/* Main Content */}
      <main className="min-h-screen bg-white pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AllysPostArticle
            post={article}
            relatedPosts={relatedArticles}
            onShare={handleShare}
            locale={locale}
            basePath="/news"
            showShareButtons={true}
            showAuthorBio={true}
            showRelatedPosts={relatedArticles.length > 0}
            messages={articleMessages}
          />
        </div>
      </main>

      {/* CTA Section */}
      <AllysCTASection
        maskBackgroundImages={[
          'https://res.cloudinary.com/elementary-media/image/upload/v1762229962/photo-1706823128655-4034c2d89ecc_oalmng.webp',
          'https://res.cloudinary.com/elementary-media/image/upload/v1762230458/premium_photo-1664304455335-602b6811149a_k6m4sa.webp',
          'https://res.cloudinary.com/elementary-media/image/upload/v1762230524/photo-1571146234274-39eb12e63910_lq6bhv.webp',
        ]}
        primaryButton={{
          text: 'View Properties',
          href: `${basePath}/properties`,
          variant: 'primary',
        }}
        locale={locale as 'en' | 'es' | 'fr'}
      />
    </>
  );
}
